import { HStack } from '@chakra-ui/react';
import React from 'react';
import MemberCareMemberNotes from '../../MemberCareMemberNotes';
import MemberCareMemberObservations from '../../MemberCareMemberObservations';
import { TMemberCareMember } from '@/types/MemberCare.types';

type Props = {
  onObservationsUpdate: () => void;
  onNotesUpdate: () => void;
  memberId: string;
  member: TMemberCareMember;
};

const NotesTab = ({ memberId, member, onObservationsUpdate, onNotesUpdate }: Props) => {
  return (
    <HStack gap={'60px'} alignItems={'start'}>
      <MemberCareMemberNotes memberId={memberId} memberFirstName={member.firstName} onNotesUpdate={onNotesUpdate} />
      <MemberCareMemberObservations memberId={memberId} onObservationsUpdate={onObservationsUpdate} />
    </HStack>
  );
};

export default NotesTab;
